import _objectSpread from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'ProductPreviews',
  props: {
    products: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnCount: {
      type: Number,
      default: 4
    },
    textAlign: {
      type: String,
      default: 'left'
    },
    showPrice: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      aspectRatio: '1:1',
      ratioPadding: null,
      sizes: null,
      widths: null,
      quickAddIsEnabled: false,
      quickAddKeepAlive: false,
      quickAddIsVisible: false,
      currentProductId: null,
      quickViewIsVisible: false,
      quickViewProduct: null,
      productBeingAdded: null
    };
  },
  fetch: function fetch() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $swell, _this$aspectRatio$spl, _this$aspectRatio$spl2, x, y;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $swell = _this.$swell;
              _context.next = 3;
              return $swell.settings.get('productPreviews.aspectRatio', '1:1');

            case 3:
              _this.aspectRatio = _context.sent;
              _context.next = 6;
              return $swell.settings.get('productList.enableQuickAdd');

            case 6:
              _this.quickAddIsEnabled = _context.sent;
              // Set ratio padding
              _this$aspectRatio$spl = _this.aspectRatio.split(':'), _this$aspectRatio$spl2 = _slicedToArray(_this$aspectRatio$spl, 2), x = _this$aspectRatio$spl2[0], y = _this$aspectRatio$spl2[1];
              _this.ratioPadding = "".concat(y / x * 100, "%"); // Set widths

              _this.widths = [192, 262, 358, 548, 716, 1096]; // Set srcset sizes

              _context.t0 = _this.columnCount;
              _context.next = _context.t0 === 2 ? 13 : _context.t0 === 3 ? 15 : _context.t0 === 4 ? 17 : 19;
              break;

            case 13:
              _this.sizes = '(min-width: 1200px) 548px, 50vw';
              return _context.abrupt("break", 19);

            case 15:
              _this.sizes = '(min-width: 1200px) 358px, (min-width: 768px) 33vw, 50vw';
              return _context.abrupt("break", 19);

            case 17:
              _this.sizes = '(min-width: 1200px) 262px, (min-width: 768px) 25vw, 50vw';
              return _context.abrupt("break", 19);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread({}, mapState(['currency', 'cartIsUpdating'])),
  methods: {
    openProduct: function openProduct(id) {
      window.location.href = "/product/" + id;
    },
    showQuickAdd: function showQuickAdd(id) {
      // If keep alive is active, don't hide until same product has been moused over again
      // This is so that for dropdown option that extend past the original element, the flow isn't lost.
      if (this.quickAddKeepAlive) {
        if (this.currentProductId !== id) return;
        this.quickAddKeepAlive = false;
      }

      this.quickAddIsVisible = true;
      this.currentProductId = id;
    },
    hideQuickAdd: function hideQuickAdd() {
      if (this.quickAddKeepAlive) return;
      this.quickAddIsVisible = false;
      this.currentProductId = null;
    },
    openQuickView: function openQuickView(product) {
      if (!product) return;
      this.quickViewProduct = product;
      this.quickViewIsVisible = true;
    },
    keepQuickAddAlive: function keepQuickAddAlive(bool) {
      this.quickAddKeepAlive = bool;
    }
  }
};